import { useLocation } from "react-router-dom";

const CulturalActivities = () => {
  const location = useLocation();
  const { eventName, eventImage } = location.state || {};

  return (
    <div>
      <h1>{eventName}</h1>
      <img src={eventImage} alt={eventName} />
    </div>
  );
};

export default CulturalActivities;
